import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import api from "../../api/api";

export const changePassword = createAsyncThunk(
	"login/changePassword",
	async (payload, { rejectWithValue }) => {
		try {
			const response = await api.put(
				"/Account/change-password-username",
				payload,
			);
			toast.success("Password changed successfully");
			return response.data;
		} catch (err) {
			const res = err.response?.data;
			toast.error(res?.Message || "change Password failed");
			return rejectWithValue(
				err.response?.data?.message || "change Password failed",
			);
		}
	},
);

const changePasswordSlice = createSlice({
	name: "changePassword",
	initialState: {
		loading: false,
		success: false,
		error: null,
	},
	reducers: {
		resetChangePasswordState: (state) => {
			state.loading = false;
			state.success = false;
			state.error = null;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(changePassword.pending, (state) => {
				state.loading = true;
				state.error = null;
			})
			.addCase(changePassword.fulfilled, (state) => {
				state.loading = false;
				state.success = true;
			})
			.addCase(changePassword.rejected, (state, action) => {
				state.loading = false;
				state.error = action.payload;
			});
	},
});

export const { resetChangePasswordState } = changePasswordSlice.actions;

export default changePasswordSlice.reducer;
